// boebackinstock.js · "עדכנו אותי כשחוזר למלאי", הטופס שלנו.
//
// מחליף את הווידג'ט של AMP Back in Stock. נטען מ-layout/theme.liquid כמו מחשבון
// המידות, כדי שלא נהיה תלויים במבנה הבלוקים של התבנית: הערכה פה רצה על ה-DOM
// שבפועל, ולכן שורדת גם כשהתבנית משתנה.
//
// הזמינות נקראת מ-/products/<handle>.js ולא מהעמוד. מה שמופיע בכפתור יכול להיות
// ישן אחרי מעבר בין מידות, והקובץ של שופיפיי הוא האמת.

const API = "https://boebody-back-in-stock.boebody.workers.dev/api/signup";

const T = {
  title: "אזל במידה הזו",
  sub: "נעדכן אותך ברגע שהיא חוזרת",
  placeholder: "האימייל שלך",
  button: "עדכנו אותי",
  sending: "רגע...",
  badEmail: "הכתובת לא נראית תקינה",
  failed: "משהו השתבש, אפשר לנסות שוב",
};

const CSS = `
.boe-bis{direction:rtl;text-align:right;margin:14px 0 0 0;padding:16px 18px;
  background:#FFF9F5;border:1px solid #ECE3D8;border-radius:16px;
  font-family:inherit;color:#3A2F25}
.boe-bis__t{font-size:15px;font-weight:700;color:#674736;margin:0 0 2px}
.boe-bis__s{font-size:13px;color:#8A6F5C;margin:0 0 12px}
.boe-bis__row{display:flex;gap:8px;flex-wrap:wrap}
.boe-bis__in{flex:1 1 180px;min-width:0;padding:11px 14px;border:1px solid #ECE3D8;
  border-radius:999px;background:#fff;font-size:14px;font-family:inherit;color:#3A2F25;
  direction:ltr;text-align:left}
.boe-bis__in:focus{outline:2px solid #674736;outline-offset:1px}
.boe-bis__btn{flex:0 0 auto;padding:11px 24px;border:0;border-radius:999px;
  background:#674736;color:#FFF9F5;font-size:14px;font-weight:700;font-family:inherit;
  cursor:pointer}
.boe-bis__btn[disabled]{opacity:.55;cursor:default}
.boe-bis__msg{margin:10px 0 0;font-size:13px;color:#674736;line-height:1.6}
.boe-bis__msg[data-err="1"]{color:#B85C5C}
`;

function injectCss() {
  if (document.getElementById("boe-bis-css")) return;
  const s = document.createElement("style");
  s.id = "boe-bis-css";
  s.textContent = CSS;
  document.head.appendChild(s);
}

function currentVariantId() {
  const fromUrl = new URLSearchParams(location.search).get("variant");
  if (fromUrl) return String(fromUrl).replace(/\D/g, "");
  // כשאין פרמטר בכתובת, השדה המוסתר של טופס העגלה הוא המקור. יש כמה טפסים בעמוד
  // (מהיר, קבוע), ולכן נלקח זה שבאמת מוביל להוספה לעגלה.
  const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
  return input ? String(input.value).replace(/\D/g, "") : "";
}

function productHandle() {
  const m = location.pathname.match(/\/products\/([^/?#]+)/);
  return m ? m[1] : "";
}

// מיקום: מיד אחרי אזור כפתורי הקנייה. אם התבנית לא חושפת אותו, נופלים לטופס עצמו,
// וזה עדיין מקום הגיוני ולא שובר שום פריסה.
function anchor() {
  return (
    document.querySelector("buy-buttons:not([class*=hidden])") ||
    document.querySelector("buy-buttons") ||
    document.querySelector('form[action*="/cart/add"]')
  );
}

function render(variantId) {
  const host = anchor();
  if (!host) return;
  let box = document.getElementById("boe-bis");
  if (!box) {
    box = document.createElement("div");
    box.id = "boe-bis";
    box.className = "boe-bis";
    box.innerHTML = `
      <p class="boe-bis__t">${T.title}</p>
      <p class="boe-bis__s">${T.sub}</p>
      <div class="boe-bis__row">
        <input class="boe-bis__in" type="email" inputmode="email" autocomplete="email"
               placeholder="${T.placeholder}" aria-label="${T.placeholder}">
        <button class="boe-bis__btn" type="button">${T.button}</button>
      </div>
      <p class="boe-bis__msg" role="status" aria-live="polite"></p>`;
    host.insertAdjacentElement("afterend", box);

    const input = box.querySelector(".boe-bis__in");
    const btn = box.querySelector(".boe-bis__btn");
    const msg = box.querySelector(".boe-bis__msg");

    const submit = async () => {
      const email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        msg.dataset.err = "1";
        msg.textContent = T.badEmail;
        input.focus();
        return;
      }
      btn.disabled = true;
      const was = btn.textContent;
      btn.textContent = T.sending;
      msg.textContent = "";
      delete msg.dataset.err;
      try {
        const r = await fetch(API, {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ email, variantId: box.dataset.variant }),
        });
        const d = await r.json();
        msg.textContent = d.message || (d.ok ? "" : T.failed);
        if (!d.ok) msg.dataset.err = "1";
        if (d.ok) {
          input.value = "";
          box.querySelector(".boe-bis__row").style.display = "none";
        }
      } catch {
        msg.dataset.err = "1";
        msg.textContent = T.failed;
      } finally {
        btn.disabled = false;
        btn.textContent = was;
      }
    };

    btn.addEventListener("click", submit);
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        submit();
      }
    });
  }

  // מעבר בין מידות מחזיר את הטופס למצב נקי: ההרשמה היא לוריאנט מסוים, ואסור
  // שהודעת ההצלחה של המידה הקודמת תישאר על המסך ותיראה כאילו נרשמת לזו החדשה.
  if (box.dataset.variant !== variantId) {
    box.dataset.variant = variantId;
    const row = box.querySelector(".boe-bis__row");
    if (row) row.style.display = "";
    const msg = box.querySelector(".boe-bis__msg");
    if (msg) {
      msg.textContent = "";
      delete msg.dataset.err;
    }
  }
  box.style.display = "";
}

function hide() {
  const box = document.getElementById("boe-bis");
  if (box) box.style.display = "none";
}

let availability = null;

// נעילת יחידות אחרונות (snippets/boe-low-stock-lock.liquid): הערכה מסמנת "אזל" וריאנט
// שנשארו בו מעט יחידות, אבל בשופיפיי הוא עדיין available=true, ולכן /products/x.js
// לבדו מסתיר את הטופס בדיוק במידות שהלקוחה רואה כאזלו. הסניפט boe-bis-lock-data
// פולט לעמוד את מפת הנעילה, והיא גוברת על available.
function lockedVariants() {
  try {
    const el = document.getElementById("boe-bis-lock");
    return el ? JSON.parse(el.textContent) : {};
  } catch {
    return {};
  }
}

async function loadAvailability() {
  const handle = productHandle();
  if (!handle) return null;
  let map = null;
  try {
    const r = await fetch(`/products/${handle}.js`, { headers: { accept: "application/json" } });
    if (r.ok) {
      const p = await r.json();
      map = {};
      for (const v of p.variants || []) map[String(v.id)] = !!v.available;
    }
  } catch {
    map = null;
  }
  for (const [id, locked] of Object.entries(lockedVariants())) {
    if (locked) {
      map = map || {};
      map[String(id)] = false;
    }
  }
  return map;
}

async function evaluate() {
  const id = currentVariantId();
  if (!id) return hide();
  if (!availability) availability = await loadAvailability();
  if (!availability) return hide();
  // ברירת המחדל כשהוריאנט לא מוכר היא להסתיר. עדיף לפספס טופס מאשר להציג
  // "אזל" על מידה שבעצם קיימת.
  if (availability[id] === false) render(id);
  else hide();
}

function start() {
  if (!location.pathname.includes("/products/")) return;
  injectCss();
  evaluate();

  // התבנית מחליפה מידות בלי טעינת עמוד, ולפעמים גם מחליפה את הטופס עצמו.
  // צפייה ב-DOM תופסת את שני המקרים בלי להסתמך על אירוע פנימי של התבנית.
  let last = currentVariantId();
  const tick = () => {
    const now = currentVariantId();
    if (now !== last) {
      last = now;
      evaluate();
    }
  };
  new MutationObserver(tick).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["value", "data-variant-id", "selected"],
  });
  window.addEventListener("popstate", () => {
    availability = null;
    last = currentVariantId();
    evaluate();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
